import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Gas({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M17.333 21.333H2.66699V20H17.333V21.333ZM15.333 2.66699C15.7011 2.66699 15.9998 2.96497 16 3.33301V18.667H14.667V4H5.33301V18.667H4V3.33301L4.00293 3.26465C4.03728 2.9287 4.32197 2.66699 4.66699 2.66699H15.333ZM20.667 6C21.035 6.00018 21.333 6.29891 21.333 6.66699V13.333C21.333 14.4376 20.4376 15.333 19.333 15.333C18.2286 15.3328 17.333 14.4375 17.333 13.333V9.33301H18L18.0684 9.33691C18.4044 9.37115 18.667 9.65489 18.667 10V13.333C18.667 13.7011 18.965 13.9998 19.333 14C19.7012 14 20 13.7012 20 13.333V7.33301H18V6H20.667ZM12.667 5.33301C13.035 5.33318 13.333 5.63192 13.333 6V10C13.333 10.3681 13.035 10.6668 12.667 10.667H7.33301C6.96497 10.6668 6.66699 10.3681 6.66699 10V6C6.66699 5.63192 6.96497 5.33318 7.33301 5.33301H12.667ZM8 9.33301H12V6.66699H8V9.33301Z"
        fill={iconColor}
      />
    </Svg>
  );
}
